import { post, get } from "../util/crmAxios";

// crm登录
export const toDoLogin = (params) => post('/crm/user/login', params)
// crm登出
export const loginOut = (params) => get('/crm/user/loginOut', params)

// 根据token获取当前登录人菜单及功能key
export const queryLogin = (params) => post('/crm/user/queryLoginNavAndFunc', params);

// 根据token获取当前登录人菜单及功能key   2021 0308  猛哥要求更换登陆接口  获取权限
export const queryUserNavAndFunc = (params) => post('/crm/user/queryUserNavAndFunc', params);

// 获取短信验证码
export const getCode = (params) => get(`/crm/user/getCode?mobile=${params.mobile}&subType=${params.subType}`);

// 找回密码（重置密码）
export const resetPassword = (params) => post('/crm/user/resetPassword', params);

// 修改密码
export const updateUserPwd = (params) => post('/crm/account/updateUserPwd', params);
// 获取当前用户所在校区身份
export const getCampusIdentity = (params) => post('/crm/user/getCampusIdentity', params);
// 查询菜单培训信息
export const queryMenuExtendInfo = (params) => get('/crm/user/queryMenuExtendInfo', params)

// 查询钉钉部门状态
export const queryUserDingStatus = (params) => get('/crm/user/queryUserDingStatus', params)
